/*
  GA4 e-commerce dogadjaji: view_item i add_to_cart.
  Dodato 02.10.2026. GA4 tag (G-M0G7RD9NLX) zivi u layout/theme.liquid; ova
  skripta samo salje dodatne dogadjaje preko vec postojeceg window.gtag.
  begin_checkout i purchase salje Releasit - njih ovde NE dirati (duplo brojanje).
  Podatke o proizvodu cita iz ShopifyAnalytics.meta (Shopify ga sam ispisuje na
  svakoj stranici proizvoda), cene su tamo u parama pa se dele sa 100.
*/
(function () {
  'use strict';

  var GA4_ID = 'G-M0G7RD9NLX';

  function posalji(naziv, parametri) {
    try {
      if (typeof window.gtag !== 'function') return;
      parametri.send_to = GA4_ID;
      window.gtag('event', naziv, parametri);
    } catch (e) {}
  }

  function valuta() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return (meta && meta.currency) || 'RSD';
  }

  /* ---------- view_item ---------- */

  function izabranaVarijanta(proizvod) {
    var id = new URLSearchParams(window.location.search).get('variant');
    if (!id) {
      var polje = document.querySelector('form[action*="/cart/add"] [name="id"]');
      id = polje && polje.value;
    }
    var varijante = proizvod.variants || [];
    for (var i = 0; i < varijante.length; i++) {
      if (String(varijante[i].id) === String(id)) return varijante[i];
    }
    return varijante[0];
  }

  function pogledaoProizvod() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (!meta || !meta.product || !meta.page || meta.page.pageType !== 'product') return;
    var v = izabranaVarijanta(meta.product);
    if (!v) return;
    var cena = Number(v.price) / 100;
    var stavka = {
      item_id: String(meta.product.id),
      item_name: v.name ? String(v.name).replace(' - ' + (v.public_title || ''), '') : document.title,
      item_brand: meta.product.vendor || undefined,
      item_category: meta.product.type || undefined,
      item_variant: v.public_title || undefined,
      price: cena,
      quantity: 1
    };
    posalji('view_item', { currency: valuta(), value: cena, items: [stavka] });
  }

  /* ---------- add_to_cart ---------- */

  function stavkaIzKorpe(s) {
    var kolicina = Number(s.quantity) || 1;
    return {
      item_id: String(s.product_id),
      item_name: s.product_title || s.title,
      item_brand: s.vendor || undefined,
      item_category: s.product_type || undefined,
      item_variant: s.variant_title || undefined,
      price: Number(s.final_price != null ? s.final_price : s.price) / 100,
      quantity: kolicina
    };
  }

  function dodaoUKorpu(odgovor, trazenaKolicina) {
    if (!odgovor || odgovor.status) return; /* status u telu = Shopify greska (npr. 422) */
    var sirovo = odgovor.items || [odgovor];
    var stavke = [];
    var ukupno = 0;
    for (var i = 0; i < sirovo.length; i++) {
      if (!sirovo[i] || !sirovo[i].product_id) continue;
      var st = stavkaIzKorpe(sirovo[i]);
      /* Shopify u odgovoru vraca ukupnu kolicinu te linije u korpi, ne koliko je sad dodato */
      if (sirovo.length === 1 && trazenaKolicina > 0) st.quantity = trazenaKolicina;
      stavke.push(st);
      ukupno += st.price * st.quantity;
    }
    if (!stavke.length) return;
    posalji('add_to_cart', { currency: valuta(), value: Math.round(ukupno * 100) / 100, items: stavke });
  }

  function jeDodavanje(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  function kolicinaIzTela(telo) {
    try {
      if (!telo) return 0;
      if (typeof FormData !== 'undefined' && telo instanceof FormData) return Number(telo.get('quantity')) || 1;
      if (typeof URLSearchParams !== 'undefined' && telo instanceof URLSearchParams) return Number(telo.get('quantity')) || 1;
      if (typeof telo === 'string') {
        if (telo.charAt(0) === '{') {
          var j = JSON.parse(telo);
          if (j.items && j.items.length === 1) return Number(j.items[0].quantity) || 1;
          return Number(j.quantity) || 1;
        }
        return Number(new URLSearchParams(telo).get('quantity')) || 1;
      }
    } catch (e) {}
    return 0;
  }

  /* fetch */
  if (typeof window.fetch === 'function') {
    var izvorniFetch = window.fetch;
    window.fetch = function (resurs, opcije) {
      var obecanje = izvorniFetch.apply(this, arguments);
      try {
        var url = typeof resurs === 'string' ? resurs : resurs && resurs.url;
        if (jeDodavanje(url)) {
          var kol = kolicinaIzTela(opcije && opcije.body);
          obecanje.then(function (odgovor) {
            if (!odgovor || !odgovor.ok) return;
            odgovor.clone().json().then(function (json) { dodaoUKorpu(json, kol); }).catch(function () {});
          }).catch(function () {});
        }
      } catch (e) {}
      return obecanje;
    };
  }

  /* XMLHttpRequest (neke aplikacije i dalje koriste XHR) */
  var izvorniOpen = XMLHttpRequest.prototype.open;
  var izvorniSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (metoda, url) {
    this._ga4Dodavanje = jeDodavanje(url);
    return izvorniOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (telo) {
    if (this._ga4Dodavanje) {
      var kol = kolicinaIzTela(telo);
      this.addEventListener('load', function () {
        try {
          if (this.status >= 200 && this.status < 300) dodaoUKorpu(JSON.parse(this.responseText), kol);
        } catch (e) {}
      });
    }
    return izvorniSend.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pogledaoProizvod);
  } else {
    pogledaoProizvod();
  }
})();
